import { request } from '../../../../lib/request';
import { SUSHI_DATA_API_HOST } from 'sushi/config/subgraph';
import { graphql } from '../../graphql';
export const PortfolioClaimablesQuery = graphql(`
    query PortfolioClaimables($id: ID!) {
      portfolioClaimables(id: $id) {
        totalUSD
        v2PositionClaimables {
          position {
            id
            chainId
            chain
            protocol
            protocolId
            protocolLogoUrl
            address
            name
            swapFee
            token0 {
              id
              chain
              chainId
              name
              symbol
              decimals
              logoUrl
              protocolId
              price
              isVerified
              isCore
              isWallet
              timeAt
              amount
              amountUSD
            }
            token1 {
              id
              chain
              chainId
              name
              symbol
              decimals
              logoUrl
              protocolId
              price
              isVerified
              isCore
              isWallet
              timeAt
              amount
              amountUSD
            }
            amountUSD
            updatedAt
          }
          token {
            id
            chain
            chainId
            name
            symbol
            decimals
            logoUrl
            protocolId
            price
            isVerified
            isCore
            isWallet
            timeAt
            amount
            amountUSD
          }
        }
        v3PositionClaimables {
          position {
            id
            chainId
            chain
            protocol
            protocolId
            protocolLogoUrl
            address
            name
            swapFee
            positionId
            range
            fees {
              id
              chain
              chainId
              name
              symbol
              decimals
              logoUrl
              protocolId
              price
              isVerified
              isCore
              isWallet
              timeAt
              amount
              amountUSD
            }
            amountUSD
            updatedAt
          }
          token {
            id
            chain
            chainId
            name
            symbol
            decimals
            logoUrl
            protocolId
            price
            isVerified
            isCore
            isWallet
            timeAt
            amount
            amountUSD
          }
        }
        smartPositionClaimables {
          token {
            id
            chain
            chainId
            name
            symbol
            decimals
            logoUrl
            protocolId
            price
            isVerified
            isCore
            isWallet
            timeAt
            amount
            amountUSD
          }
          position {
            id
            chainId
            chain
            protocol
            protocolId
            protocolLogoUrl
            address
            name
            vaultAddress
            swapFee
            strategy
            amountUSD
            updatedAt
          }
        }
        furoClaimables {
          position {
            id
            chainId
            chain
            protocol
            protocolId
            protocolLogoUrl
            address
            name
            positionId
            updatedAt
          }
          token {
            id
            chain
            chainId
            name
            symbol
            decimals
            logoUrl
            protocolId
            price
            isVerified
            isCore
            isWallet
            timeAt
            amount
            amountUSD
          }
        }
      }
    }
`);
export async function getPortfolioClaimables(variables, options) {
    const url = `https://${SUSHI_DATA_API_HOST}`;
    const result = await request({ url, document: PortfolioClaimablesQuery, variables }, options);
    if (result) {
        return result.portfolioClaimables;
    }
    throw new Error('No portfolio positions');
}
